import { Classes } from "@blueprintjs/core";
import React from "react";
import styled, { css } from "styled-components";
import draftToHtml from 'draftjs-to-html';
import { Intent } from "core/components/IntentContext";
import { IViewProps, View } from "core/decorators/View";
import Paragraph from "./Paragraph";
import TypographyViewConfig from "./TypographyViewConfig";
import IntrinsicElements = JSX.IntrinsicElements;
import convertToHtml from "common/fragments/ConvertToHtml";

// html5 tags
export enum TypographyVariant {
	ARTICLE = "article",
	SECTION = "section",
	SUMMARY = "summary",
	LEGEND = "legend",
	LABEL = "label"
}

const headings = Object.values(TypographyVariant);

interface ITypographyViewProps extends IViewProps<TypographyViewConfig, TypographyVariant> {
	html?: string; // for database fields that are html from wicket admin
	autoSkeleton?: boolean; // display in skeleton mode when in Intent == Loading. default = true
}

@View({id: "typography", configClass: TypographyViewConfig, variants: TypographyVariant})
export default class TypographyView extends React.PureComponent<ITypographyViewProps> {

	public render() {
		const { config, children, style, variant, intent, html, autoSkeleton = true } = this.props;

		const tagName: keyof IntrinsicElements = headings.includes(variant) ? variant : 'p';
		const elementStyle = {...style || {}, ...config.typography || {}, color: config.color};

		// multi line skeleton. heading has single line skeleton
		if(autoSkeleton && Intent.LOADING === intent) {
			const length =  config.lineClamp || 2; // default 2

			return Array.from({length}, (v, i) => (
				<div key={i} style={{...elementStyle, marginBottom: length - 1 !== i && "8px"} as any} className={Classes.SKELETON}>........</div>
			));
		}

		const props = {tagName, config, style: elementStyle};

		if (!!html) {
			return React.createElement(Paragraph, {...props, dangerouslySetInnerHTML: {__html: convertToHtml(html)}})
		}
		return React.createElement(Paragraph, props, children);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/typographyView/Typography.view.tsx